import { render, staticRenderFns } from "./FormasDePagamento.vue?vue&type=template&id=31158a99&"
import script from "./FormasDePagamento.vue?vue&type=script&lang=js&"
export * from "./FormasDePagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports